<header class="page-head" data-testid="lists-section">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-list"></i></span>
    <div>
      <h1 class="page-head__title">Listas</h1>
      <p class="page-head__subtitle">
        Listas manuais e automáticas que recebem os leads das suas automações e integrações.
      </p>
    </div>
  </div>
  <div class="page-head__actions">
    <a [routerLink]="['/lists/new']" class="sf-btn sf-btn--primary sf-btn--icon-right" data-testid="btn-new-list">
      Nova lista <i class="fa fa-plus-circle"></i>
    </a>
  </div>
</header>

<div class="notice notice--warning" *ngIf="!user?.validated">
  <i class="fa fa-exclamation-triangle"></i>
  <div class="notice__body">
    <span data-testid="span-msg-unvalidated-user">ATENÇÃO: Por enquanto você pode montar seus funis de vendas apenas com listas automáticas, integradas com as
      diversas
      plataformas disponíveis no menu integrações. Após a validação do seu cadastro você poderá criar listas manuais, onde
      você poderá importar sua lista de
      leads ou realizar a integração diretamente do seu website. Para agilizar a liberação destas funcionalidades, entre
      em contato conosco através do suporte clicando
      <a [href]="supportLink" target="_blank">aqui</a>.
    </span>
  </div>
</div>

<div class="notice notice--success" *ngIf="migrationNotify">
  <i class="fa fa-info-circle"></i>
  <div class="notice__body">
    A migração está em andamento. Assim que finalizar você será notificado.
  </div>
</div>

<div class="filter-bar">
  <div class="search-wrap grow">
    <i class="fa fa-search"></i>
    <input type="text" name="name" class="form-control" placeholder="Digite o nome da lista para pesquisar"
      [(ngModel)]="name" (keyup)="filterKeyPress($event)" data-testid="input-search-lists" />
    <button type="button" class="search-go" (click)="pageChanged(page)" data-testid="btn-search-lists" aria-label="Pesquisar">
      <i class="fa fa-search"></i>
    </button>
  </div>

  <div class="type-toggles">
    <div class="toggle-item">
      <app-switcher id="dinamic_list" [checked]="onlyDynamicLists" (checkedChange)="toggleDinamicLists($event)"></app-switcher>
      <span class="toggle-item__label" (click)="toggleDinamicLists(!onlyDynamicLists)">Mostrar somente listas dinâmicas?</span>
    </div>
    <div class="toggle-item">
      <app-switcher id="manual_list" [checked]="onlyManualLists" (checkedChange)="toggleManualLists($event)"></app-switcher>
      <span class="toggle-item__label" (click)="toggleManualLists(!onlyManualLists)">Mostrar somente listas manuais?</span>
    </div>
  </div>
</div>

<div class="filter-bar filter-bar--selects">
  <div class="field">
    <label for="integration_id">Integração</label>
    <app-search-select
      name="integration_id"
      [(ngModel)]="integrationId"
      [options]="integrationOptions"
      [loading]="loadingIntegrations"
      placeholder="Todas"
      searchPlaceholder="Pesquisar integração…"
      emptyText="Nenhuma integração encontrada"
      noun="integrações"
      testId="filter-integration"
      (selectionChange)="filterByIntegration()"
    ></app-search-select>
  </div>
</div>

<app-skeleton *ngIf="loadingLists" variant="table-row" [count]="6" [columns]="3"
  label="Carregando suas listas" data-testid="lists-loading"></app-skeleton>

<div class="sf-card empty" *ngIf="!loadingLists && loadError" data-testid="lists-error">
  <i class="fa fa-exclamation-triangle"></i>
  <p>Não foi possível carregar as listas.</p>
  <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm" (click)="listPaginated()" data-testid="btn-retry-lists">
    <i class="fa fa-refresh"></i> Tentar de novo
  </button>
</div>

<div *ngIf="!loadingLists && !loadError && result?.data.length > 0">
  <div class="row-card" [class.is-inactive]="!list.manual && !list.integration?.active" *ngFor="let list of result.data" data-testid="list-item">
    <span class="row-avatar">
      <i class="fa" [class.fa-list-ul]="list.manual" [class.fa-rocket]="!list.manual"></i>
    </span>

    <div class="info">
      <div class="name">
        <a class="name-link" [routerLink]="['/lists/edit', list.id]">{{ list.name }}</a>
        <span class="status-pill status-pill--sm status-pill--warn" *ngIf="list.importing">Importando…</span>
      </div>

      <div class="meta-line">
        <span class="meta-chip">{{ list.manual ? 'Manual' : 'Automática' }}</span>
        <span class="meta-chip" *ngIf="list.dynamic">Dinâmica</span>

        <ng-container *ngIf="!list.manual">
          <span class="bind-chip bind-chip--plat">{{ list.integration?.platform?.name }}</span>
          <span class="bind-chip bind-chip--danger" *ngIf="!list.integration?.active" ngbTooltip="Integração desativada não receberá os postbacks!">
            Desativada <i class="fa fa-info-circle"></i>
          </span>
        </ng-container>

        <span class="meta-chip" title="Data último lead"><i class="fa fa-clock-o"></i> {{ (list.last_lead_date | date:'dd/MM/yyyy, H:mm') || '-' }}</span>
      </div>

      <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm legacy-btn" *ngIf="showLegacyButton(list)"
        ngbTooltip="Solicitar Dados Legados" (click)="confirmLegacy(list)" data-testid="btn-legacy-list">
        Solicitar Dados Legados
      </button>
      <span class="legacy-hint" *ngIf="showLegacyPendingHint(list)">
        O botão será liberado após a conclusão do processamento da outra lista.
      </span>
    </div>

    <div class="stats">
      <div class="stat"><b>{{ list.leads_count || '0' }}</b><span>Leads</span></div>
    </div>

    <div class="icon-group">
      <a class="sf-btn sf-btn--primary sf-btn--icon sf-btn--sm" ngbTooltip="Editar" data-testid="edit-btn" [routerLink]="['/lists/edit', list.id]">
        <i class="fa fa-pencil"></i>
      </a>
      <button type="button" class="sf-btn sf-btn--danger sf-btn--icon sf-btn--sm" ngbTooltip="Excluir" data-testid="btn-delete-list" (click)="confirmDelete(list)">
        <i class="fa fa-trash"></i>
      </button>
    </div>
  </div>
</div>

<!-- "Nenhuma lista cadastrada!" piscava antes de a primeira resposta chegar,
     porque o ramo `else` entra em cena com `result` ainda indefinido. -->
<div class="sf-card empty" *ngIf="!loadingLists && !loadError && result?.data.length === 0">
  <i class="fa" [class.fa-search]="name" [class.fa-list]="!name"></i>
  <p data-testid="not-found-message">Nenhuma lista {{ name ? 'encontrada' : 'cadastrada' }}!</p>
  <a *ngIf="!name" [routerLink]="['/lists/new']" class="sf-btn sf-btn--primary sf-btn--sm">
    <i class="fa fa-plus-circle"></i> Nova lista
  </a>
</div>

<app-pagination *ngIf="!loadingLists && !loadError && result" [currentPage]="result.current_page" [itemsPerPage]="result.per_page"
  [totalItems]="result.total" (pageChanged)="pageChanged($event)"></app-pagination>

<ng-template #modalExclusao let-modal>
  <div>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title"><i class="fa fa-ban"></i> Impossível excluir no momento</h4>
      <button type="button" class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm" aria-label="Fechar" (click)="modal.dismiss()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="notice notice--warning notice--sm">
        <i class="fa fa-exclamation-triangle"></i>
        <div class="notice__body">
          Para excluir esta lista, você deve desvincular a lista da(s) campanha(s):
          <ul>
            <li *ngFor="let campaign of deleteListCampaigns"><a (click)="modal.dismiss()" ngbTooltip="Clique para acessar a campanha" [href]="'/#/campaigns/edit/' + campaign.id">{{ campaign.name }}</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="sf-btn sf-btn--primary" (click)="modal.dismiss()">OK</button>
    </div>
  </div>
</ng-template>
